export default __webpack_public_path__ + "static/AGB_THG_Quoten-d9248c16950a77c8f419c063ec1eac43.pdf";